import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsClose = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <path
        fill="currentColor"
        d="M21.5507221,0.7800747l-9.5041428,9.5053587L2.5412214,0.7800747L0.7482396,2.5718391
	l9.5065765,9.5065756l-9.5065765,9.5053596l1.7917644,1.7917633l9.5053596-9.5053587l9.5053587,9.5053587l1.7905483-1.7917633
	l-9.5029259-9.5053596l9.5041428-9.5053596L21.5507221,0.7800747z"
      />
    </SvgIcon>
  );
});

export default AppIconsClose;
